module.exports = __webpack_public_path__ + "resources/img/img_alyac3_m_en.704f9bd00f2ac32538b9e355160649c6.png";